import { api } from './client'

/**
 * L'invitation à découvrir une fonctionnalité — F22, [DECISIONS §366].
 *
 * **Ben, le 22 août 2026** : « les users ne sont pas assez curieux pour
 * découvrir toutes les fonctionnalités […] il faut à des intervalles
 * raisonnables afficher des trucs le guidant vers l'utilisation des
 * fonctionnalités jamais utilisées ou oubliées depuis un bon moment. »
 */
export type Invitation = {
  /** La clé du catalogue, telle que le serveur la nomme. */
  feature: string
  titre: string
  /** Ce que ça apporte au candidat, écrit pour lui. */
  promesse: string
  /** Où mène le bouton. */
  destination: string
}

/**
 * L'invitation du moment, ou `null` s'il faut se taire.
 *
 * **Cet appel ÉCRIT côté serveur**, ce qui surprend pour un GET et n'est pas un
 * oubli : la cadence compte les invitations SERVIES. Une carte qu'on fait
 * défiler sans y toucher est une réponse ; sans cette écriture on en servirait
 * une neuve à chaque page du Fil. Il ne doit donc pas être rejoué à la légère —
 * une seule fois par consultation.
 */
export async function invitationCourante(): Promise<Invitation | null> {
  const reponse = await api<{ invitation: Invitation | null }>('/decouverte')

  return reponse.invitation
}

/** « Pas maintenant » — deux refus et l'on n'en reparle plus jamais. */
export async function refuserLInvitation(feature: string): Promise<void> {
  await api(`/decouverte/${encodeURIComponent(feature)}/refus`, { method: 'POST' })
}

/**
 * Une visite, pour les TROIS fonctionnalités qu'aucun geste ne mesure — le
 * classement se regarde, les notifications s'autorisent, et **les archives se
 * lisent** ([DECISIONS §381]).
 *
 * Les archives ont rejoint la liste le 30 août : elles étaient définies par
 * « une réponse enregistrée », mais l'écran garde ses réponses en état local
 * et n'en envoie aucune. Le compteur valait zéro sur 6 091 questions.
 *
 * Partout ailleurs l'usage se lit dans la table qui porte le geste : appeler
 * ceci pour les cours ne ferait rien, et le serveur refuse.
 */
export async function noterLaVisite(
  feature: 'classement' | 'notifications' | 'archives',
): Promise<void> {
  await api(`/decouverte/${feature}/visite`, { method: 'POST' })
}
